function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o);
}
var _excluded = ["to", "label", "children", "description", "icon", "className", "variant"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t)
    return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i))
        return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
} return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e)
    return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++)
        o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
} return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r)
    return {}; var t = {}; for (var n in r)
    if ({}.hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n))
            continue;
        t[n] = r[n];
    } return t; }
import { Link as RouterLink } from 'react-router-dom';
import cn from 'classnames';
import './Link.scss';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var Link = function Link(_ref) {
    var to = _ref.to, label = _ref.label, children = _ref.children, description = _ref.description, icon = _ref.icon, className = _ref.className, _ref$variant = _ref.variant, variant = _ref$variant === void 0 ? 'default' : _ref$variant, rest = _objectWithoutProperties(_ref, _excluded);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [/*#__PURE__*/ _jsxs(RouterLink, _objectSpread(_objectSpread({
                to: to,
                className: cn('link', {
                    'link-default': variant === 'default',
                    'link--button': variant === 'button',
                    'link--logo': variant === 'logo',
                    'link--svg': variant === 'svg',
                    'link--img': variant === 'img'
                }, className)
            }, rest), {}, {
                children: [icon && /*#__PURE__*/ _jsx("span", {
                        className: "link-icon",
                        children: icon
                    }), children !== null && children !== void 0 ? children : label]
            })), description && /*#__PURE__*/ _jsx("div", {
                className: "link-description",
                children: description
            })]
    });
};
export default Link;
